import { LANGUAGES } from "../constants";

export const getLocalizedPath = (path = "/") => {
  const { pathname } = window.location;
  const currentLang =
    LANGUAGES.find((lang) => lang && pathname.startsWith(lang)) || "";
  return `${currentLang}${path}`;
};
